var React = require('react');

function LandingPageHeroBlobLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M63.6 0C49.2 20.4 37.9 42.4 30.5 65.4c-31.7 100.2 10.5 219.4 5 351.5-1.6 47-9.2 95.5-16.5 143.1H0V0h63.6z","fill":"currentColor"}));
}

LandingPageHeroBlobLeftInline.defaultProps = {"width":"64","height":"560","viewBox":"0 0 64 560"};

module.exports = LandingPageHeroBlobLeftInline;

LandingPageHeroBlobLeftInline.default = LandingPageHeroBlobLeftInline;
